// @flow
import React from 'react';

import PhotoSlider from '../../components/PhotoSlider';
import { connect } from 'react-redux';
import type { MediaObject } from '../../flowtypes/media';

type Props = {
  photos: Array<MediaObject>,
  mediaUrl: string
}

const ProductPhotoSlider = ({ photos, mediaUrl }: Props) => (
  <PhotoSlider photos={photos} mediaUrl={mediaUrl} />
)

const mapStateToProps = state => {
  return {
    photos: state.media,
    mediaUrl: state.product.mediaUrl
  }
};

export default connect(mapStateToProps)(ProductPhotoSlider);



// WEBPACK FOOTER //
// ./src/containers/ProductPhotoSlider/index.js